import * as props from './Parcel/props';
import {Icon} from './Parcel/Icon';

require('../../sass/components/_parcel-type.scss');

export const Parcel = {
    name: 'Parcel',
    components: {
        Icon
    },
    props: {
        type: props.type,
        label: String,
        size: String,
        isSelectable: Boolean
    },
    computed: {
        iconClasses() {
            return ['parcel-type__icon', 'parcel-type__icon--' + this.size];
        },
        rootClasses() {
            return ['parcel-type', this.isSelectable && 'parcel-type--selectable', 'parcel-type--' + this.size];
        },
        component() {
            if (this.isSelectable) {
                return 'label';
            }
            return 'div';
        }
    },
    template: `
    <component :is="component" :class="rootClasses" v-bind="$attrs">
        <div :class="iconClasses">
          <Icon :type="type" :withSelection="isSelectable"/>
        </div>
        <span class="parcel-type__name">{{label}}</span>
    </component>
`
};